import React, { Component } from "react";
import { Table, Accordion } from "semantic-ui-react";
import _ from "lodash";
import { getNodeValue } from "../../common/Utils";
import { getFormattedPhone } from "../../common/Phone";

class PhoneSilver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const phoneNodes = [];
    if (this.props.node !== undefined) {
      const phoneInfos = _.get(this.props.node, "phone");
      if (phoneInfos !== undefined) {
          _.forEach(phoneInfos, (phoneInfo, index) => {
            const phone = getNodeValue(phoneInfo, "phoneNumber");
            if (phone !== "") {
              const providerType = getNodeValue(phoneInfo, "carrierType");
              phoneNodes.push(
                <Table.Row
                  key={`phone_row_${index}`}
                  className={index % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell>
                    <span className="text-bold">Phone</span>
                  </Table.Cell>
                  <Table.Cell>{getFormattedPhone(phone)}</Table.Cell>
                  <Table.Cell>
                    {providerType !== "" && (
                      <span className="text-bold">Type</span>
                    )}
                  </Table.Cell>
                  <Table.Cell>{providerType !== "" && providerType}</Table.Cell>
                </Table.Row>
              );
              phoneNodes.push(
                <Table.Row
                  key={`phone_carrier_row_${index}`}
                  className={index % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell>
                    <span className="text-bold">Carrier</span>
                  </Table.Cell>
                  <Table.Cell colSpan={12}>
                    {getNodeValue(phoneInfo, "carrier")}
                  </Table.Cell>
                </Table.Row>
              );
            }
            // }
          });
        
      }
    }
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`PhoneTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Current Phone
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`PhoneBody`}
          active={this.state.activeIndex === 0}
        >
          <Table className="table-no-border">
            <Table.Body>{phoneNodes}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default PhoneSilver;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/PhoneSilver.js